import React from "react";
import EditAboutUs from "./EditAboutUs";
import EditDeals from "./EditDeals";
import EditStore from "./EditStore";
import StoreSettings from "./EditStore/StoreSettings";
import EditWebsite from "./EditWebsite";
import EditRewards from "./EditRewards";
import EditBackground from "./EditBackground";
import EditTextComponent from "./EditTextComponent";
import EditPunchCard from "./EditPunchCard";
import EditRotatingImageGalleryComponent from "./EditRotatingImageGalleryComponent";
import EditPictureCatalogComponent from "./EditPictureCatalogComponent";
import PunchCardSettings from "./EditPunchCard/PunchCardSettings";
import { withRedux } from "helpers";
import { Input, SaveProgress } from "components";
import { Form, FormContainer, H2, Button } from "appStyles";
import { imageView } from "defaultStates";
import Modal from "@material-ui/core/Modal";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "react-emotion";

const bodyStyle = css`
  width: 100%;
`;
const toastStyle = css`
  border: 2.5px solid rgb(137, 210, 211);
  z-index: 1400;
`;

class EditTemplate extends React.Component {
  state = {
    croppingAspectRatio: "1.0",
  };

  updateComponent = (component, isTemp = false) => {
    const { activeTemplate } = this.props;
    // console.log("updating this active template");
    // console.dir(activeTemplate);

    // console.log("using this component");
    // console.dir(component);

    const updatedTemplate = {
      ...this.props.activeTemplate,
    };
    updatedTemplate.components = activeTemplate.components.map((c) =>
      c.componentNumber === component.componentNumber ? component : c
    );

    this.props.actions.updateTemplate(updatedTemplate);
  };

  updateBackgroundColor = (backgroundColor) => {
    const updatedTemplate = {
      ...this.props.activeTemplate,
      backgroundColor,
    };

    this.props.actions.updateTemplate(updatedTemplate);
  };

  updateBackgroundImage = (url) => {
    let updatedTemplate = this.props.activeTemplate;
    if (url) {
      if (updatedTemplate.backgroundImage === null) {
        updatedTemplate = {
          ...this.props.activeTemplate,
          backgroundImage: imageView(url),
        };
      } else {
        updatedTemplate = {
          ...this.props.activeTemplate,
          backgroundImage: {
            ...this.props.activeTemplate.backgroundImage,
            url,
          },
        };
      }
    } else {
      updatedTemplate = {
        ...this.props.activeTemplate,
        backgroundImage: null,
      };
    }

    this.props.actions.updateTemplate(updatedTemplate);
  };

  update = (value) => {
    this.setState({ croppingAspectRatio: value });
    if (this.props.activeTemplate.type === "pictureCatalog") {
      // console.log("changing cropRatio to: " + value);
    }
  };

  toggleActiveEditor = (idx) => {
    let {
      actions: { updateActiveEditor },
    } = this.props;
    // console.log("@@@@@@ closing MODAL", idx);
    updateActiveEditor(idx);
  };

  shouldDisplayForm = () => {
    const { activeTemplate, activeEditor } = this.props;

    // We want to always display bottom form for these template types
    if (
      [
        "aboutUs",
        "deals",
        "website",
        "rewards",
        "pictureCatalog",
        "store",

        "punchCard",
      ].includes(activeTemplate.type)
    ) {
      return true;
    } else if (activeEditor !== null) {
      // don't display form if no editor is selected
      return true;
    }

    return false;
  };

  get pageEditors() {
    return [
      "aboutUs",
      "deals",
      "website",
      "rewards",
      "punchCard",
      "store",
      "pictureCatalog",
    ];
  }

  get componentEditors() {
    return ["titleText", "imageTitleText", "rotatingImageGallery"];
  }

  get additionalPageSettings() {}

  renderPageEditor = () => {
    const { activeTemplate } = this.props;

    if (!this.pageEditors.includes(activeTemplate.type)) return null;
    const pageEditorsPage = {
      aboutUs: <EditAboutUs />,
      deals: <EditDeals />,
      store: <EditStore />,
      website: <EditWebsite />,
      rewards: <EditRewards />,
      punchCard: <EditPunchCard />,
      pictureCatalog: (
        <EditPictureCatalogComponent updateComponent={this.updateComponent} />
      ),
    };
    // console.log("GOT ACTIVE TEMPLATE TYPE: " + activeTemplate.type);
    return pageEditorsPage[activeTemplate.type];
  };

  render() {
    const { activeApp, activeTemplate, activeEditor } = this.props;

    const { croppingAspectRatio } = this.state;

    // handle unique component background requirement
    const isAtRewards = activeTemplate.type === "rewards";
    const isAtDeals = activeTemplate.type === "deals";
    const isAtPunchCards = activeTemplate.type === "punchCard";
    const isAtStore = activeTemplate.type === "store";
    const isAtPictureCatalog = activeTemplate.type === "pictureCatalog";

    return (
      // <FormContainer top={isAtDeals ? '93%' : '8em'} left={isAtDeals ? '18%' : '11em'} width='55%'>
      <div style={{ width: "580px" }}>
        {!isAtRewards &&
          !isAtDeals &&
          !isAtStore &&
          !isAtPunchCards &&
          !isAtPictureCatalog && (
            <div
              style={{
                marginTop: "1em",
                padding: "1em",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                position: "relative",
                padding: "1em",
                borderRadius: "5px",
                marginBottom: "3em",
              }}
            >
              <EditBackground
                croppingAspectRatio={croppingAspectRatio}
                update={this.update}
                updateComponent={this.updateComponent}
                pictureCatalogComponent={
                  activeTemplate.type === "pictureCatalog"
                    ? activeTemplate.components[0]
                    : false
                }
                updateBackgroundColor={this.updateBackgroundColor}
                updateBackgroundImage={this.updateBackgroundImage}
                backgroundColor={activeTemplate.backgroundColor}
                backgroundImage={activeTemplate.backgroundImage}
                additionalPageSettings={this.additionalPageSettings}
                appId={activeApp.id}
              />
              <SaveProgress />
            </div>
          )}

        <div
          hidden={!this.shouldDisplayForm()}
          style={{
            marginBottom: "3em",
            background: isAtRewards || isAtDeals ? "none" : "white",
            padding:
              activeEditor ||
              ["website", "pictureCatalog"].includes(activeTemplate.type)
                ? "1em"
                : 0,
          }}
        >
          {this.renderPageEditor()}
          {this.componentEditors.includes(activeTemplate.type) &&
            activeTemplate.components.map((c) => {
              if (activeEditor === null) return null;
              // only render the editor component if it's active
              if (activeEditor === c.componentNumber) {
                return React.createElement(componentEditors[c.type], {
                  component: c,
                  updateComponent: this.updateComponent,
                  appId: activeApp.id,
                  activeApp: activeApp,
                  key: c.componentNumber,
                  onClose: this.toggleActiveEditor,
                });
              }
            })}
          {/* {!isAtRewards && !isAtDeals && !isAtPunchCard && <SaveProgress />} */}
          <div>
            <ToastContainer
              position="bottom-right"
              autoClose={3000}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable={false}
              pauseOnHover
              transition={Slide}
              closeButton={false}
              bodyClassName={bodyStyle}
              toastClassName={toastStyle}
            />
          </div>
        </div>
      </div>
    );
  }
}

const componentEditors = {
  text: EditTextComponent,
  rotatingImageGallery: EditRotatingImageGalleryComponent,
};

export default withRedux(EditTemplate);
